var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoPurple = function SvgLogoPurple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9428 5.05675C92.3589 3.97386 94.3847 4.24398 95.4676 5.66008L116.449 33.097L111.32 37.0185L90.3394 9.58156C89.2565 8.16546 89.5267 6.13963 90.9428 5.05675Z",
    fill: "#f198ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.11286,
    height: 27.3386,
    rx: 4.55643,
    transform: "matrix(0.92388 -0.382683 0 -1 94.8671 112.083)",
    fill: "#f198ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.11286,
    height: 27.3386,
    rx: 4.55643,
    transform: "matrix(-4.03841e-08 -1 -0.92388 0.382683 111.705 95.9939)",
    fill: "#f198ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.096 96.8671C127.771 97.8301 125.886 96.5708 125.886 94.0544V75.8286C125.886 73.3122 127.771 70.4915 130.096 69.5285C132.421 68.5655 134.305 69.8249 134.305 72.3413V90.567C134.305 93.0835 132.421 95.9041 130.096 96.8671ZM132.342 77.468L125.886 84.2835V77.4679L132.342 77.468Z",
    fill: "#f198ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.47 23.3074L158.099 47.6557C159.657 48.2428 160.688 49.7338 160.688 51.3989V127.859C160.688 129.52 159.661 131.009 158.108 131.598L84.7606 159.44C82.8018 160.184 80.5971 159.852 78.9442 158.564L52.102 137.656L51.1772 100.667L86.3981 136.269C88.0778 137.967 90.6045 138.507 92.8314 137.644L147.178 116.584C148.333 116.137 149.094 115.026 149.094 113.787V58.9845C149.094 57.7662 148.358 56.6689 147.23 56.2078L104.053 38.5471C102.597 37.9516 100.965 37.9517 99.5096 38.5471L43.7151 61.3684C42.5875 61.8296 41.8508 62.9268 41.8508 64.1451V79.8757L38.0302 75.0999L20.277 55.2581V53.5991C20.277 51.9635 21.2728 50.4927 22.7914 49.8852L89.1263 23.3513C90.5179 22.7946 92.0674 22.779 93.47 23.3074Z",
    fill: "#f198ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7438 60.4378C16.7454 59.7988 15.4352 60.5158 15.4352 61.7012V119.39C15.4352 121.225 16.2751 122.96 17.715 124.098L50.9232 150.341C52.8903 151.896 55.7833 150.495 55.7833 147.987V86.9726C55.7833 85.6087 55.0883 84.3387 53.9395 83.6035L17.7438 60.4378ZM22.5764 73.3201C21.5776 72.6909 20.277 73.4088 20.277 74.5893V107.31C20.277 108.249 20.7169 109.134 21.4657 109.701L43.6941 126.537C44.682 127.285 46.0997 126.58 46.0997 125.341V89.794C46.0997 88.7634 45.5707 87.805 44.6987 87.2556L22.5764 73.3201Z",
    fill: "#f198ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1187 100.328C25.1187 99.1653 26.3838 98.4446 27.3837 99.0374L39.7879 106.392C40.6992 106.932 41.2579 107.913 41.2579 108.972V114.15C41.2579 115.37 39.8802 116.08 38.8873 115.372L26.3773 106.454C25.5876 105.891 25.1187 104.981 25.1187 104.011V100.328Z",
    fill: "#f198ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17697 43.4852C3.59307 42.4023 5.6189 42.6724 6.70178 44.0885L27.6828 71.5255L22.5546 75.447L1.57363 48.01C0.490743 46.5939 0.760866 44.5681 2.17697 43.4852Z",
    fill: "#f198ff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoPurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-purple.0cdcab2d.svg";
export { ForwardRef as ReactComponent };